import styled from "@emotion/styled";
import { Drawer , Theme} from "@mui/material";
import Config from "@/config.json";

const openedMixin = (theme:Theme) => ({
    width: Config.drawerWidth,
    borderRight: `1px solid ${theme.palette.divider}`,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    backgroundColor : `${theme.palette.primary.main}` , 
    boxShadow: 'none' 
});
  
const closedMixin = (theme:Theme) => ({
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    width: 0,
    borderRight: 'none',
    backgroundColor : `${theme.palette.primary.main}` , 
    boxShadow: theme.customShadows.z1
});

const MiniDrawerStyled = styled(Drawer , { shouldForwardProp: (prop) => prop !== 'open' })(({ theme , open }:{theme:Theme , open:boolean}) => ({
    width: Config.drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    // boxSizing: 'border-box',
    ...(open && {
        ...openedMixin(theme) ,
        '& .MuiDrawer-paper': openedMixin(theme)
    }) ,
    ...(!open && {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': closedMixin(theme)
    })
}));


export default MiniDrawerStyled;